export const DEFAULT_VAT_RATE = 20;

export const domainsToSkipFixAppointment = ['serrurerie'];
